// path/to/DownloadService.ts
import axios from 'axios';

export const DownloadService = {
  downloadFile: async (
    url: string,
    onProgress: (progress: number) => void
  ): Promise<Blob> => {
    const response = await axios.get(url, {
      responseType: 'blob',
      onDownloadProgress: (progressEvent) => {
        const total = progressEvent.total || 0;
        const current = progressEvent.loaded;
        const percent = Math.round((current * 100) / total);
        onProgress(percent);
      },
    });
    return response.data;
  },

  /**
   * Scarica un file da un URL e lo converte in ArrayBuffer
   * @param url L'URL del file da scaricare
   * @returns Promise con l'ArrayBuffer del file
   */
  downloadFileToArrayBuffer: async (
    url: string,
    onProgress: (progress: number) => void
  ): Promise<ArrayBuffer> => {
    try {
      const response = await axios.get(url, {
        responseType: 'arraybuffer',
        onDownloadProgress: (progressEvent) => {
          const total = progressEvent.total || 0;
          const current = progressEvent.loaded;
          const percent = Math.round((current * 100) / total);
          onProgress(percent);
        },
      });
      if (!response) {
        throw new Error(`Errore durante il download: ${response}`);
      }
      return await response.data;
    } catch (error) {
      console.error('Errore durante il download del file:', error);
      throw {
        phase: 'DOWNLOAD',
        detail: {
          message: 'Errore durante il download del file',
          code: '001',
        },
      };
    }
  },
};
